export default __webpack_public_path__ + "static/media/silhouette-guy2.8e617c4c.svg";